document.addEventListener('DOMContentLoaded', function () {
    const collapses = document.querySelectorAll('.product-section .product-collapse');

    collapses.forEach((item) => {
      item.removeAttribute('open');
    });

    collapses.forEach((item) => {
      const summary = item.querySelector('summary');
      const content = item.querySelector('.prose');

      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();

          const isOpen = item.hasAttribute('open');

          collapses.forEach((el) => {
            el.removeAttribute('open');
            el.classList.remove('open');
            const elContent = el.querySelector('.prose');
            if (elContent) elContent.style.maxHeight = '0';
          });

          if (!isOpen) {
            item.setAttribute('open', '');
            item.classList.add('open');
            if (content) {
              content.style.maxHeight = content.scrollHeight + 'px';
            }
          }
        });
      }
    });
  });